import { render, staticRenderFns } from "./FormInput.vue?vue&type=template&id=6f0799ff"
import script from "./FormInput.vue?vue&type=script&lang=js"
export * from "./FormInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src724620054/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f0799ff')) {
      api.createRecord('6f0799ff', component.options)
    } else {
      api.reload('6f0799ff', component.options)
    }
    module.hot.accept("./FormInput.vue?vue&type=template&id=6f0799ff", function () {
      api.rerender('6f0799ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/portals/Administration/Stores/ShippingRates/FormInput.vue"
export default component.exports